import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'recruitmentCalendar';

const recruitmentCalendarService = {
  getCalendarDays: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/calendarDays`,
      data,
    });
  },
};
export default recruitmentCalendarService;
